import { PLAYER_ROLES, StaffRolePermission, } from '@la/types';
export const isPlayer = (registrant) => {
    return (typeof registrant.role !== 'undefined' &&
        PLAYER_ROLES.includes(registrant.role));
};
export const isStaff = (registrant) => {
    return typeof registrant.roles !== 'undefined';
};
/**
 * Determine permissions, giving the least restrictive based on the
 * staff roles the user has.
 * @param userStaffRoles Roles the user has
 * @returns Permissions the user does and does not have
 */
export const mapStaffRolePermissions = (userStaffRoles) => {
    return userStaffRoles.reduce((perms, role) => {
        Object.keys(perms).forEach((p) => {
            const key = p;
            if (role[key]) {
                perms[key] = true;
            }
        });
        return perms;
    }, {
        [StaffRolePermission.UserSelectable]: false,
        [StaffRolePermission.AllowSelfRegistration]: false,
        [StaffRolePermission.AllowJoinTeam]: false,
        [StaffRolePermission.AllowInviteStaff]: false,
        [StaffRolePermission.AllowInviteThisRole]: false,
        [StaffRolePermission.AllowInvitePlayers]: false,
        [StaffRolePermission.AllowManagedStaffManagedFields]: false,
        [StaffRolePermission.AllowSubmitRoster]: false,
        [StaffRolePermission.AllowCheckin]: false,
        [StaffRolePermission.AllowAddEditScores]: false,
    });
};
/**
 * Merges permissions of two staff role permissions objects so that the
 * least restrictive version is returned.
 */
export const mergeStaffRolePermissions = (a, b) => {
    const merged = {};
    for (const key of Object.values(StaffRolePermission)) {
        merged[key] = a[key] || b[key];
    }
    return merged;
};
